import classNames from 'classnames';
import {LucideIcon} from 'lucide-react';
import * as React from 'react';

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
    icon: LucideIcon;
}

export const EmptyState: React.FunctionComponent<EmptyStateProps> = ({icon: Icon, className, children, ...rest}: EmptyStateProps) => (
    <div className={classNames('mp-empty-state', className)} {...rest}>
        <Icon size={24} className="mp-empty-state__icon"/>
        <p className="mp-empty-state__text">{children}</p>
    </div>
);
